define('rest/routing',["http", "./utils", "security"], function (http, utils, security) {
    "use strict";

    var queryParamNames = [
        "maxAlternatives", "routeType", "traffic", "instructionsType", "language", "departAt", "arriveAt",
        "computeBestOrder", "routeRepresentation", "travelMode", "hilliness", "windingness", "report",
        "computeTravelTimeFor", "vehicleEngineType", "vehicleMaxSpeed", "vehicleWeight", "vehicleAxleWeight",
        "vehicleLength", "vehicleWidth", "vehicleHeight", "vehicleCommercial", "vehicleHeading"];

    function isEmpty(values) {
        return !values || !values.length;
    }

    function getMultipleParamQueryString(values, name, firstParam) {
        if (isEmpty(values)) {
            return "";
        }
        return (firstParam ? "?" : "&") + name + "=" + values.join("&" + name + "=");
    }

    return {
        calculateRoute: function (options, callback) {
            var pathParams = {},
                queryParams = {},
                queryStringAvoid,
                queryStringVehicleLoadType;

            queryParams.key = utils.or(options.key, security.getKey("services/routing"));

            pathParams.locations = utils.required(options.locations);

            // language
            queryParams.language = utils.or(options.language, "en-GB");

            // look for not required passed params and set them if they are not undefined
            utils.extractQueryParams(options, queryParams, queryParamNames);

            queryStringAvoid = getMultipleParamQueryString(options.avoid, "avoid", true);
            queryStringVehicleLoadType = getMultipleParamQueryString(options.vehicleLoadType, "vehicleLoadType", !queryStringAvoid);

            // Define service call
            var baseUrl = utils.required(utils.or(options.baseUrl, "{protocol}://api.tomtom.com/routing/1/"));
            var serviceUrl = utils.required(utils.or(options.serviceUrl, "calculateRoute/{locations}/{contentType}"));

            http.get({
                url: baseUrl + serviceUrl + queryStringAvoid + queryStringVehicleLoadType,
                pathParameters: pathParams,
                queryParameters: queryParams,
                callbackParam: "callback",
                callback: callback,
                fail: options.fail
            });
        }
    };
});

